import React, { useContext } from 'react';
import { AppSidebar, AppSidebarMenuItem } from '@redpanda/ui';
import {
  PresentationChartBarIcon,
  UsersIcon,
  LightBulbIcon,
  DocumentTextIcon,
  BriefcaseIcon,
  ListBulletIcon,
  CreditCardIcon,
  TagIcon,
  DocumentChartBarIcon,
} from '@heroicons/react/24/outline';
import ThemeSelector from './ThemeSelector';
import { UserContext } from '../context/UserContext';
import { useTranslation } from 'react-i18next';
import { Language } from '@redpanda/types';
import { useLocation } from 'react-router-dom';
import { opportunityHomePath } from '../utils/opportunityView';

interface SidebarProps {
  className?: string;
  isMobileOpen?: boolean;
  onCloseMobile?: () => void;
}

const menuItems: AppSidebarMenuItem[] = [
  { path: '/', labelKey: 'navbar.dashboard', icon: PresentationChartBarIcon },
  { path: '/customers', labelKey: 'navbar.customers', icon: UsersIcon },
  { path: '/opportunities', labelKey: 'navbar.opportunities', icon: LightBulbIcon },
  { path: '/quotes', labelKey: 'navbar.quotes', icon: DocumentTextIcon },
  { path: '/projects', labelKey: 'navbar.projects', icon: BriefcaseIcon },
  { path: '/tasks', labelKey: 'navbar.tasks', icon: ListBulletIcon },
  { path: '/payments', labelKey: 'navbar.payments', icon: CreditCardIcon },
  { path: '/tags', labelKey: 'navbar.tags', icon: TagIcon },
  { path: '/reports', labelKey: 'navbar.reports', icon: DocumentChartBarIcon },
];

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { user, logout, updateUserLanguage } = useContext(UserContext)!;
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  return (
    <AppSidebar
      appName="RedPanda CRM"
      menuItems={menuItems.map(item => (item.path === '/opportunities' ? { ...item, path: opportunityHomePath(pathname), activePath: '/opportunities' } : item))}
      user={user}
      currentLanguage={i18n.language}
      onLanguageChange={(lng) => {
        if (updateUserLanguage) updateUserLanguage(lng as Language);
        else i18n.changeLanguage(lng);
      }}
      onLogout={logout}
      themeSelector={<ThemeSelector />}
      currentSystem="CRM"
      {...props}
    />
  );
};

export default Sidebar;
